import { X } from "lucide-react";

export default function Modal({ title, icon, onClose, children, footer }) {
  return (
    <div
      className="fixed inset-0 bg-stone-900/40 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-in fade-in duration-200"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-6 py-4 border-b border-stone-100 bg-stone-50/50 flex justify-between items-center">
          <h3 className="text-lg font-semibold text-stone-800 flex items-center gap-2">
            {icon}
            {title}
          </h3>
          <button
            className="text-stone-400 hover:text-stone-600 transition-colors"
            onClick={onClose}
          >
            <X size={20} />
          </button>
        </div>
        <div className="p-6">{children}</div>
        {footer && (
          <div className="px-6 py-4 border-t border-stone-100 bg-stone-50/50">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
